module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/自动摆盘机.3389a7d7.png";